import ReactMustache from 'react-mustache'

import axios from "../utils/axios";
import { cWarn } from '../components/igtm/CustomLogger';


export const defaultState = {
    isLoading: true,
    addNewLoading:true,
    editLoading:true,
    openLoading:true,
    isOpenOpen:false,
    formFields: [],
    addNewIntitialValues:{},
    editNewIntitialValues:{},
    results: '',
    textData:[],
    editId:false,
    deleteId:false,
    openId:false,
    isAddFormOpen: false,
    isEditFormOpen: false,
    isDeleteFormOpen: false,
    showOpen:false,
    workingOpenId:0,
    workingUnit:{},
    isLoadingOpen:true
};

export const handleClickOpenAddForm = (context) => {
    getAddNewFields(context);
    context.setState({
        isAddFormOpen:true
    });
}


export const handleClickCloseAddForm = (context) => {
    context.setState({
        addNewLoading:true,
        isAddFormOpen:false
    });
}

export const handleClickOpenOpen = (id,context) => {
    
    const apiPath = `${process.env.REACT_APP_API_URL}${context.unitPath}details/${id}`;
    context.setState({
        openLoading:true,
        isOpenOpen:true,
        openId:id
    });

    axios.get(apiPath,{
        timeout: 30000,
        withCredentials:true
    }).then(res => {
        let {data} = res;
        if(context.prepareOpen){
            data = context.prepareOpen(data);
        }
    
        context.setState({
            openLoading:false,
            detailData:data,
        })
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });
    
}

export const handleClickCloseOpen = (context) => {
    
    context.setState({
        isOpenOpen:false
    });
}

export const setOpenToClose = (context) => {
    context.setState({
        showOpen:false
    });
}

export const getAddNewFields = (context,processFields) => {
    const apiPath = `${process.env.REACT_APP_API_URL}${context.unitPath}fields`;
    axios.get(apiPath,{
        timeout: 30000,
        withCredentials:true
    }).then(res => {
        let initialValues = {};
        const keys = Object.keys(res.data);
        const values = Object.values(res.data);
        for (let i = 0; i < keys.length; i += 1) {
            initialValues[keys[i]] = ('default' in values[i] ? values[i].default : '');
        }
        let fields =  res.data;
        if(processFields){
            fields = processFields(res.data);
        }
        if(context.modFields){
            fields = context.modFields(fields);
        }
        if(context.modInitialValues){
            initialValues = context.modInitialValues(initialValues);
        }
        context.setState({
            addNewLoading:false,
            addNewIntitialValues:initialValues,
            formFields:fields
        })
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });

}


export const getSingularEditFields = (context,processFields,widgetContext) => {
    const apiPath = `${process.env.REACT_APP_API_URL}${context.unitPath}editfields/`;
   // console.log(apiPath);
    context.setState({
        editLoading:true,
    });

    axios.get(apiPath,{
        timeout: 30000,
        withCredentials:true
    }).then(res => {
        const initialValues = {};
        const keys = Object.keys(res.data.editFields);
        const values = Object.values(res.data.editFields);
        
        for (let i = 0; i < keys.length; i += 1) {
            initialValues[keys[i]] = values[i].value;
        }
        let fields =  res.data.editFields;
        if(processFields){
            fields = processFields(res.data.editFields);
        }
       // console.log(initialValues);
        context.setState({
            textData:res.data.textData,
            editLoading:false,
            editIntitialValues:initialValues,
            formFields:fields,
            fieldArr:values,
            isLoading:false
        })
        if(widgetContext){
            widgetContext.setState({
                isLoaded:true,
                textData:res.data.textData
            });
        }
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });
}

export const getEditFields = (id,context,processFields) => {
    const apiPath = `${process.env.REACT_APP_API_URL}${context.unitPath}editfields/${id}`;
    context.setState({
        editLoading:true,
        editId:id,
    });

    axios.get(apiPath,{
        timeout: 30000,
        withCredentials:true
    }).then(res => {
        const initialValues = {};
        const keys = Object.keys(res.data);
        const values = Object.values(res.data);
        for (let i = 0; i < keys.length; i += 1) {
            initialValues[keys[i]] = values[i].value;
        }
        let fields =  res.data;
        if(processFields){
            fields = processFields(res.data);
        }
        context.setState({
            editLoading:false,
            editIntitialValues:initialValues,
            editId:id,
            formFields:fields
        })
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });
}


export const renderText = (textResource,unitKeys,textKey) => {

    const keys = Object.keys(unitKeys);
    const values = Object.values(unitKeys);
    const templateData = {};
    for(let i=0; i<keys.length; i+=1){
        templateData[keys[i]] = textResource[values[i]];
    }


    return ( <ReactMustache Component="span" template={textResource[textKey]} data={templateData} />);
}

export const addNew = (values, actions,context,callBack) => {

    if(context.modAddValues){
        values = context.modAddValues(values);
    }

    const formData = new FormData();
    const keys = Object.keys(values);
    const formValues = Object.values(values);



    for (let i = 0; i < keys.length; i += 1) {
        if (Object.prototype.hasOwnProperty.call(formValues, i)) {
            if (typeof formValues[i] === 'object' && formValues[i] !== null && 'id' in formValues[i]) {
                formData.append(keys[i], formValues[i].id);
            } else {
                formData.append(keys[i], formValues[i]);
            }
        }
    }
    const apiPath = `${process.env.REACT_APP_API_URL}${context.unitPath}`;
    axios.post(apiPath,formData,{
        timeout: 30000,
        withCredentials:true,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((res) => {
        context.setState({
            isLoading:true,
        })
        loadData(context);
        if(callBack){
            callBack(res.data);
        }
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });

    handleClickCloseAddForm(context);
}

export const handleClickOpenEditForm = (id,context) => {
    getEditFields(id,context);
    context.setState({
        isEditFormOpen:true
    });
}
export const handleClickOpenSingularEditForm = (context) => {
    
    context.setState({
        isEditFormOpen:true
    });
}

export const handleClickCloseEditForm = (context) => {
    context.setState({
        isEditFormOpen:false
    });
}

export const handleClickOpenDeleteDialogue = (id,context) => {
    context.setState({
        deleteId:id,
        isDeleteFormOpen:true
    });
}

export const handleClickCloseDeleteDialogue = (context) => {
    context.setState({
        isDeleteFormOpen:false
    });
}






export const editSingularSubmit = (values, actions, context) => {
   // console.log(values);
    const formData = new FormData();
    const keys = Object.keys(values);
    const formValues = Object.values(values);
    for (let i = 0; i < keys.length; i += 1) {
        if (Object.prototype.hasOwnProperty.call(formValues, i)) {
//            // console.log(`${keys[i]} :: ${formValues[i]}`);
            if(formValues[i] instanceof File) {
                // console.log(formValues[i])
                formData.append(keys[i], formValues[i]);
            }
            else{
                formData.append(keys[i], formValues[i]);
            }            
        }
    }
    const apiPath = `${process.env.REACT_APP_API_URL}${context.unitPath}`;
    axios.post(apiPath,formData,{
        timeout: 30000,
        withCredentials:true,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then(() => {
        context.setState({
            isLoading:true,
        })
        getSingularEditFields(context);
        
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });
    handleClickCloseEditForm(context);
}

export const editSubmit = (values, actions, context,callBack) => {
   // console.log(values);
    const formData = new FormData();
    const keys = Object.keys(values);
    const formValues = Object.values(values);
    for (let i = 0; i < keys.length; i += 1) {
        if (Object.prototype.hasOwnProperty.call(formValues, i)) {
//            // console.log(`${keys[i]} :: ${formValues[i]}`);
            if(formValues[i] !== undefined){
                formData.append(keys[i], formValues[i]);
            }
            
        }
    }
    const apiPath = `${process.env.REACT_APP_API_URL}${context.unitPath}${context.editId}`;
    axios.post(apiPath,formData,{
        timeout: 30000,
        withCredentials:true,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((res) => {
        context.setState({
            isLoading:true,
        })
        loadData(context);
        if(callBack){
            callBack(res.data);
        }
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });
    handleClickCloseEditForm(context);
}

export const deleteUnit = (context,callBack) => {
    const apiPath = `${process.env.REACT_APP_API_URL}${context.unitPath}${context.deleteId}`;
    axios.delete(apiPath,{
        timeout: 30000,
        withCredentials:true,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((res) => {
        context.setState({
            isLoading:true,
        })
        loadData(context);
        if(callBack){
            callBack(res.data);
        }
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });
    handleClickCloseDeleteDialogue(context);
}

export const loadData = (context,widgetContext) => {
   // console.log('loading data');
    context.setState({
        isLoading:true
    });
    const apiPath = `${process.env.REACT_APP_API_URL}${context.unitPath}`;
    axios.get(apiPath,{
        timeout: 30000,
        withCredentials:true
    }).then(res => {
        context.setState({
            isLoading:false,
            results:res.data.results,
            textData:res.data.textData
        })
        
        if(widgetContext){
            widgetContext.setState({
                isLoaded:true,
                textData:res.data.textData
            });
        }
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });

}

export const setWorkingItemById = (context,id) => {
    if(context.results.length > 0){
        for(let i=0; i<context.results.length; i+=1){
            if(context.results[i].id === id){
                context.setState({
                    workingItem: context.results[i]
                });
                break;
            }
        }
    }
}
